"use client";
import {Button} from "@/components/ui/button";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {useState} from "react";
import * as yup from "yup";
import {Form} from "@/components/ui/form";
import {CWFInput} from "@/components/ui/CWFInput";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import CWFButton from "@/components/ui/CWFButton";
import CWFSelect from "@/components/ui/CWFSelect";
import {openTrainingFilters} from "@/lib/helpers/SearchStatus";

const formOpenTrainingSchema = yup.object({
    name : yup.string().nullable(),
    period : yup.string().nullable(),
})

export default function SearchFilter(){
    const router = useRouter();

    const searchParams = useSearchParams();
    const pathname = usePathname();
    const {replace} = useRouter();

    const formOpenTrain = useForm({
        resolver: yupResolver(formOpenTrainingSchema),
    })

    function searchOpenTraining(data){
        const params = new URLSearchParams(searchParams);

        if(data.name !== undefined){
            params.set('name', data.name);
        }

        if(data.period !== undefined){
            params.set('period', data.period);
        }

        replace(`${pathname}?${params.toString()}`);
    }




    return(
        <Form {...formOpenTrain}>
            <form onSubmit={formOpenTrain.handleSubmit(searchOpenTraining)} className={"grid gap-x-4 gap-y-2 grid md:grid-cols-7"}>
                <CWFInput
                    placeholder={"Nom de l'event"}
                    className={"md:col-span-4"}
                    control={formOpenTrain.control}
                    name={"name"}
                />
                <CWFSelect
                    name={"period"}
                    className={"md:col-span-2"}
                    placeholder={"Filtrer"}
                    control={formOpenTrain.control}
                    items={openTrainingFilters}
                />
                <CWFButton>Rechercher</CWFButton>
            </form>
        </Form>

    )
}
